<template>
  <main class="page-main company">
    <section class="page-heading-wrap">
      <html-view tag="h3" class="page-heading" :value="$t('company.head')" />
      <html-view class="page-heading-desc" :value="$t('company.copy')" />
    </section>

    <section class="page-visual" data-style="show">
      <picture>
        <source media="(min-width: 750px)" srcset="~@/static/image/company/pc/visual.jpg">
        <source media="(max-width: 750px)" srcset="~@/static/image/company/m/visual.jpg">
        <img src="~@/static/image/company/pc/visual.jpg" :alt="$t('company.head')">
      </picture>
    </section>

    <navigation :tab-list="tabList" />

    <router-view />
  </main>
</template>
<script>
import gtag from '@/mixins/gtag'
import navigation from '@/components/base/Navigation'
import isKorean from '@/mixins/isKorean'

export default {
  components: {
    navigation,
  },
  mixins: [gtag, isKorean],
  data () {
    return {
      tabList: [
        {
          pathname: 'company-culture',
          title: 'menuCompany.woowaCulture'
        },
        {
          pathname: 'company-history',
          title: 'menuCompany.history'
        },
      ],
      // sections: [
      //  'ethicalManagement',
      //  'compliance',
      //  'sustainable'
      // ],
      // sectionTitles: [
      //  'menuCompany.ethicalManagement',
      //  'menuCompany.compliance',
      //  'sustainable.name'
      // ]
    }
  },
  mounted () {
    setTimeout(this.init, 800)
  },
  methods: {
    init () {
      // this.sections.forEach((section, index) => {
      //   // console.log(this.$refs[section]?.$el)
      //   if (this.$refs[section]) {
      //     this.initGtag({
      //       element: this.$refs[section]?.$el,
      //       isView: true,
      //       ga: {
      //         name: '회사소개_지속가능경영',
      //         category: '회사소개_지속가능경영',
      //         label: this.$t(this.sectionTitles[index]),
      //         page: '회사소개'
      //       }
      //     })
      //   }
      // })
    },
  }
}
</script>
